module.exports = __webpack_public_path__ + "img/home3.1781104d.svg";